import { useEffect, useState } from 'react';

type Media = {
  url: string | null;
};

type MediaApiObject = {
  big: Media;
  medium: Media;
  small: Media;
  thumb: Media;
  url: string | null;
};

const isBlob = (obj: Blob | MediaApiObject): obj is Blob => obj instanceof Blob;

const useImage = (object: Blob | MediaApiObject | null | undefined) => {
  const [image, setImage] = useState<string | undefined>(undefined);

  useEffect(() => {
    let img: string | null | undefined;
    if (object) {
      if (isBlob(object)) {
        img = URL.createObjectURL(object);
      } else if (object.url) {
        img = object.url;
      }
    }

    setImage(img ?? undefined);

    return () => {
      setImage(undefined);
    };
  }, [object]);

  return image;
};

export default useImage;
